<template>
  <section class="ine-form" style="position: relative;">
    <div class="auth-form__container">
      <AuthenticationBackground />
      <Spinner
        v-show="isLoading"
        :label="''"
        class="auth-form__wrapper auth-form__spinner"
      />
      <div v-show="!isLoading" class="auth-form__wrapper">
        <div class="auth-form__forms">
          <ForgotPasswordForm
            class="auth-form__form"
            :isLoading="isLoading"
            @submit-form="submitForm"
          />
          <div class="auth-form__form-footer">
            <p class="ine-form__link-wrapper--lead">
              Don't Have an Account?
            </p>
            <a
              :href="`//${checkoutUrl}`"
              class="ine-link ine-form__link--signup"
            >
              Sign up
            </a>
          </div>
        </div>
        <AdditionalLinks
          :isTabletFooter="true"
          class="auth-form__form-footer-links"
        />
      </div>
    </div>
  </section>
</template>

<script>
import AuthenticationBackground from '@/components/forms/elements/AuthenticationBackground.vue'
import ForgotPasswordForm from '@/components/forms/ForgotPasswordForm.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'
import Spinner from '@/components/loaders/LoadingSpinnerV2.vue'

export default {
  name: 'ForgotPassword',
  components: {
    AuthenticationBackground,
    ForgotPasswordForm,
    AdditionalLinks,
    Spinner,
  },
  metaInfo() {
    return {
      title: 'INE - Forgot Password',
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    checkoutUrl() {
      return process.env.VUE_APP_CHECKOUT_URL
    },
  },
  methods: {
    isFormLoading(value) {
      this.isLoading = value
    },
    async submitForm({ email }) {
      this.isLoading = true
      await this.$store.dispatch('auth/triggerForgotPassword', email)
      this.isLoading = false
    },
  },
}
</script>
